import { render } from "./driver-document-upload.vue?vue&type=template&id=34b81ac2"
import script from "./driver-document-upload.vue?vue&type=script&lang=js"
export * from "./driver-document-upload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__